import { createUseMutationHook } from './createUseMutationHook';

export const useAviaSearchCreate = createUseMutationHook(
    'create_avia_search',
    () => [],
);
